import { render, staticRenderFns } from "./PaginaInexistente.vue?vue&type=template&id=1a37469c&scoped=true&"
import script from "./PaginaInexistente.vue?vue&type=script&lang=js&"
export * from "./PaginaInexistente.vue?vue&type=script&lang=js&"
import style0 from "./PaginaInexistente.vue?vue&type=style&index=0&id=1a37469c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a37469c",
  null
  
)

export default component.exports